
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms-of-service/business",
      function () {
        return require("private-next-pages/terms-of-service/business/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms-of-service/business"])
      });
    }
  